import { render, staticRenderFns } from "./IceModal.vue?vue&type=template&id=740a6da7&"
import script from "./IceModal.vue?vue&type=script&lang=js&"
export * from "./IceModal.vue?vue&type=script&lang=js&"
import style0 from "./IceModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports